import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function OriginStory() {
  return <section className="w-full bg-bg-alt py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-251">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-253">
          <div className="space-y-3 text-[16px] text-text-secondary italic leading-[1.45] mb-5" data-id="element-254">
            <p data-id="element-255">
              AirGuard Technologies was founded after a simple, disturbing
              discovery: most families in the U.S. are protected by CO detectors
              that expired years ago — and have absolutely no way of knowing it.
            </p>
            <p data-id="element-256">
              The green light stays on. The sensor is dead. And every night,
              families go to sleep trusting a device that can't protect them.
            </p>
            <p data-id="element-257">
              We built AirGuard Pro for one reason: so your family never has to
              find out the hard way.
            </p>
          </div>
          <div className="flex items-center justify-center gap-2 text-[14px] text-text-secondary font-medium" data-id="element-258">
            <Shield className="w-4 h-4 text-accent-orange" data-id="element-259" />
            <span data-id="element-260">
              AirGuard Technologies — Professional CO Protection Since 2024
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}